import { BreadcrumbItemProvider } from "@/types/resource";


export const PUSH_BREADCRUMB_PROVIDER = 'OD/PUSH_BREADCRUMB_PROVIDER'
export const POP_BREADCRUMB_PROVIDER = 'OD/POP_BREADCRUMB_PROVIDER'
export const RESET_BREADCRUMBS_PROVIDERS = 'OD/RESET_BREADCRUMBS_PROVIDERS'
export const RESTORE_BREADCRUMBS_PROVIDERS = 'OD/RESTORE_BREADCRUMBS_PROVIDERS'


export interface PushBreadcrumbProviderAction {
  readonly type: typeof PUSH_BREADCRUMB_PROVIDER;
  readonly payload: BreadcrumbItemProvider;
}

export interface PopBreadcrumbProviderAction {
  readonly type: typeof POP_BREADCRUMB_PROVIDER;
  readonly pathname: string;
}

export interface ResetBreadcrumbsProvidersAction {
  readonly type: typeof RESET_BREADCRUMBS_PROVIDERS;
}

export interface RestoreBreadcrumbsProvidersAction {
  readonly type: typeof RESTORE_BREADCRUMBS_PROVIDERS;
}


export const raisePushBreadcrumbProvider = (payload: BreadcrumbItemProvider): PushBreadcrumbProviderAction => ({
  type: PUSH_BREADCRUMB_PROVIDER,
  payload,
})

export const raisePopBreadcrumbProvider = (pathname: string): PopBreadcrumbProviderAction => ({
  type: POP_BREADCRUMB_PROVIDER,
  pathname,
})

export const raiseResetBreadcrumbsProviders = (): ResetBreadcrumbsProvidersAction => ({
  type: RESET_BREADCRUMBS_PROVIDERS
})

export const raiseRestoreBreadcrumbsProviders = (): RestoreBreadcrumbsProvidersAction => ({
  type: RESTORE_BREADCRUMBS_PROVIDERS
})



